export default __webpack_public_path__ + "static/media/biznis.9999800c.png";